import { motion } from "framer-motion";
import { ShieldCheck, ChevronLeft, Video, Wifi, Signal, BatteryFull } from "lucide-react";

const MESSAGES = [
  {
    text: "PEANUT ALERT: Mr Chen's Szechuan Chilli Oil 250g. Undeclared peanut. National recall. Details: foodrecallalerts.com.au/r/a1b2c3",
    delay: 0.5,
  },
  {
    text: "LISTERIA ALERT: Enoki Mushroom 200g. Listeria contamination. VIC/NSW/SA. Details: foodrecallalerts.com.au/r/k9m2xp",
    delay: 1.1,
  },
];

/** iPhone-style device mock showing the real product artifact: the SMS. */
export const PhonePreview = () => (
  <motion.div
    initial={{ opacity: 0, y: 30, rotate: -2 }}
    animate={{ opacity: 1, y: 0, rotate: 0 }}
    transition={{ type: "spring", stiffness: 60, damping: 14, delay: 0.2 }}
    className="relative mx-auto w-full max-w-[310px]"
    data-testid="phone-preview"
  >
    {/* physical side buttons */}
    <span className="absolute -left-[3px] top-[110px] h-9 w-[3px] rounded-l-sm bg-slate-700" />
    <span className="absolute -left-[3px] top-[158px] h-14 w-[3px] rounded-l-sm bg-slate-700" />
    <span className="absolute -right-[3px] top-[140px] h-20 w-[3px] rounded-r-sm bg-slate-700" />

    {/* titanium frame */}
    <div className="rounded-[3rem] bg-gradient-to-b from-slate-500 via-slate-800 to-slate-600 p-[3px] shadow-[0_30px_60px_-12px_rgba(15,23,42,0.45)]">
      <div className="rounded-[2.9rem] bg-slate-950 p-[9px]">
        <div className="relative overflow-hidden rounded-[2.3rem] bg-white">
          {/* status bar */}
          <div className="relative flex items-center justify-between px-6 pb-1 pt-2.5 text-[11px] font-semibold text-slate-900">
            <span className="tracking-tight">9:41</span>
            <div className="flex items-center gap-1">
              <Signal className="h-3 w-3" strokeWidth={2.5} />
              <Wifi className="h-3 w-3" strokeWidth={2.5} />
              <BatteryFull className="h-3.5 w-3.5" strokeWidth={2} />
            </div>
            {/* dynamic island */}
            <span className="absolute left-1/2 top-1.5 h-[22px] w-[76px] -translate-x-1/2 rounded-full bg-slate-950" />
          </div>

          {/* conversation header */}
          <div className="flex items-center justify-between border-b border-slate-200/80 bg-slate-50/80 px-3 pb-2 pt-1.5 backdrop-blur">
            <ChevronLeft className="h-4 w-4 shrink-0 text-blue-500" strokeWidth={2.5} />
            <div className="flex min-w-0 flex-col items-center">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-red-700 text-[9px] font-bold text-white">
                FR
              </span>
              <span className="mt-0.5 truncate text-[10px] font-semibold text-slate-800">FOODALERT</span>
            </div>
            <Video className="h-4 w-4 shrink-0 text-blue-500" strokeWidth={2.5} />
          </div>

          {/* thread */}
          <div className="space-y-2.5 px-3 pb-2 pt-3">
            <p className="text-center text-[10px] font-medium text-slate-400">
              <span className="font-semibold text-slate-500">Today</span> 10:32 am
            </p>
            {MESSAGES.map((m) => (
              <motion.div
                key={m.text}
                initial={{ opacity: 0, y: 14, scale: 0.94 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ type: "spring", stiffness: 120, damping: 15, delay: m.delay }}
                className="flex"
              >
                <div className="max-w-[86%] rounded-[18px] rounded-bl-[5px] bg-slate-200/90 px-3 py-2">
                  <p className="text-[12.5px] leading-[1.35] text-slate-900">{m.text}</p>
                </div>
              </motion.div>
            ))}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.6 }}
              className="pl-1 text-[9.5px] font-medium uppercase tracking-wide text-slate-400"
            >
              Delivered
            </motion.p>

            {/* input bar */}
            <div className="flex items-center gap-2 pt-1.5">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-slate-200 text-sm leading-none text-slate-500">
                +
              </span>
              <div className="flex-1 rounded-full border border-slate-200 px-3 py-1.5 text-[11px] text-slate-400">
                Text Message
              </div>
            </div>
            {/* home indicator */}
            <div className="flex justify-center pb-1 pt-1.5">
              <span className="h-[4px] w-24 rounded-full bg-slate-900/80" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <motion.div
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.7, type: "spring", stiffness: 140 }}
      className="absolute -right-5 top-1/2 hidden items-center gap-1.5 rounded-full border border-emerald-200 bg-white px-3 py-1.5 shadow-lg lg:flex"
    >
      <ShieldCheck className="h-3.5 w-3.5 text-emerald-600" />
      <span className="text-[11px] font-semibold text-slate-700">Straight from FSANZ</span>
    </motion.div>
  </motion.div>
);
